<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="page_8">As he sat at the kitchen table waiting for his mother to rewrite the list, he realized that he couldn’t see the color of his mother’s vivid blue eyes. Or the details of her face, which was remarkably unlined for someone in her seventies.</a></p><a id="page_8">
<p class="indent">Kevin didn’t say anything. He didn’t want to alarm her further. He took the rewritten grocery list from his mother’s outstretched hand and glanced at it. He still couldn’t make out the words. Reluctant to cause additional worry but unable to return to Waldbaum’s with the proffered list, he asked again.</p>
<p class="indent">“Mom, would you please make the words a bit bigger? I guess I’m tired from being out late last night, and I’m still having a hard time reading the list.”</p>
<p class="indent">Kevin hadn’t been out late the night before—in fact he hadn’t been out at all. Ruth was no longer able to hide her growing concern.</p>
<p class="indent">“You need to see an eye doctor first thing next week,” she said adamantly. “Please promise me you’ll make an appointment when you get back to the city.”</p>
<p class="indent">Kevin nodded his agreement. He then cast his eyes over the new grocery list with its oversized letters written in black felt-tipped pen on a yellow legal pad. His mother gave him an anxious look. He simply touched her shoulder and headed back to Waldbaum’s to complete his shopping.</p>
<p class="indent">Kevin didn’t discuss his eyesight with his father that day, but he overheard his mother talking to him.</p>
<p class="indent">“Walter, Kevin is having problems with his eyesight, and I’m worried.”</p>
<p class="indent">Kevin walked out of earshot of the conversation. He didn’t want to hear the rest. Kevin could no longer convince himself, much less his parents, that his poor eyesight could be corrected with a pair of reading glasses.</p>
</a><p class="center"><a id="page_8"></a><a id="page_9">* * *</a></p><a id="page_9">
<p class="indent">By the time Kevin returned to his apartment that evening, he knew something was very wrong. It was as if the lights were being dimmed. If he couldn’t understand what was going on, he could at least numb it.</p>
<p class="indent">He reached for the vodka.</p>
<p class="indent">He poured himself a full glass leaving only enough room for a splash of cranberry juice. He paused when he took the container from the fridge.</p>
<p class="indent">Something was strange.</p>
<p class="indent">He picked up a carton of orange juice. He blinked rapidly, shook his head, and looked once more at the drink containers, comparing them side-by-side. He shook his head, blinked again and rubbed his eyes.</p>
<p class="indent">Kevin was no longer able to see colors.</p>
<div class="box">
<p class="image"><img alt="images" src="images/st.png"/></p>
<p class="bh"><b>S<span class="small">ELECTED JOURNAL ENTRY:</span></b></p>
<p class="bnoindent"><i>August 14, 2013—entering the bathroom at 1 a.m., I am perplexed and mesmerized by the reflection of light in my medicine cabinet mirror. I think I must be dreaming or imagining it</i>.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_Chapter01_Part_02.vue?1b1550ed